import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { SECCCION_CUATRO } from '../../../directories/collections';
import { setEnlaceDos, setEnlaceUno, setTitleEnlace } from '../../../helpers/contenido';
import { useForm } from '../../../hooks/ useForm';
import { setEnlaceTitle, setEnlace_Dos, setEnlace_Uno } from '../../../reducer/ContenidoReducer';
import Loading from '../../tools/Loading'
const Enlaces = ({data, email, idAsig, idTema}) => {
    const dispatch = useDispatch();
    const [loadingTitle, setLoadingTitle] = useState(false)
    const [loadingEnlaceUno, setLoadingEnlaceUno] = useState(false)
    const [loadingEnlaceDos, setLoadingEnlaceDos] = useState(false)
    const [edit, setEdit] = useState(false)
    const {title,link1, link2, namelink2, namelink1, id } = data
    const [value, handleInputChange] = useForm({
        upTitle: title, upNameLink1: namelink1, upNameLink2: namelink2,
        upLink1: link1, upLink2: link2
    });
    const {upTitle,upNameLink1,upNameLink2,upLink1,upLink2} = value

    const handleUpTitle = () => {
        setLoadingTitle(true)
        setTitleEnlace(email,idAsig,idTema,SECCCION_CUATRO,id,upTitle)
        .then(() => {
            dispatch(setEnlaceTitle(upTitle))
            setLoadingTitle(false)
        })
    }

    const handleUpEnlace1 = () => {
        setLoadingEnlaceUno(true)
        setEnlaceUno(email,idAsig,idTema,SECCCION_CUATRO,id,upLink1,upNameLink1)
        .then(() => {
            dispatch(setEnlace_Uno(upLink1,upNameLink1))
            setLoadingEnlaceUno(false)
        })
    }

    const handleUpEnlace2 = () => {
        setLoadingEnlaceDos(true)
        setEnlaceDos(email,idAsig,idTema,SECCCION_CUATRO,id,upLink2,upNameLink2)
        .then(() => {
            dispatch(setEnlace_Dos(upLink2,upNameLink2))
            setLoadingEnlaceDos(false)
        })
    }

    return (
        <div className='sec4'>
            <div className='title_sec'>
                {
                    edit
                    ? <div className='form_up_title_sec'>
                        <input type='text' 
                        name='upTitle' 
                        value={upTitle} onChange={handleInputChange} placeholder='Titulo de la sección'/>
                        {
                            loadingTitle
                            ? <Loading />
                            :<i className='fas fa-save'
                                onClick={handleUpTitle}
                            ></i>
                        }
                        </div>
                    :<h1 className='cont_txt_title'>{title}</h1>
                }
            </div>
            <div className='enlace1'>
                {
                    edit
                    ?
                        <div className='btn_controls_enlace'>
                            <input type='text' placeholder='Nombre del enlace' 
                                value={upNameLink1} name='upNameLink1' onChange={handleInputChange}
                            />
                            <input type='url' placeholder='Enlace'
                                value={upLink1} name='upLink1' onChange={handleInputChange}
                            />
                            {
                                loadingEnlaceUno
                                ? <Loading />
                                :<i className='fas fa-save' onClick={handleUpEnlace1}></i>
                            }
                            
                        </div>
                
                    :
                        <div className='item-Enlace'>
                            <span>{namelink1} </span>
                            <a href={link1} target='_blank' rel='noreferrer'> Click Aquí</a>
                        </div>
                }
            </div>
            <div className='enlace2'>
                {
                    edit
                    ?
                        <div className='btn_controls_enlace'>
                            <input type='text' placeholder='Nombre del enlace' 
                                value={upNameLink2} name='upNameLink2' onChange={handleInputChange}
                            />
                            <input type='url' placeholder='Enlace'
                                value={upLink2} name='upLink2' onChange={handleInputChange}
                            />
                            {
                                loadingEnlaceDos
                                ? <Loading />
                                :<i className='fas fa-save' onClick={handleUpEnlace2}></i>
                            }
                        </div>
                
                    :
                        <div className='item-Enlace'>
                            <span>{namelink2} </span>
                            <a href={link2} target='_blank' rel='noreferrer'> Click Aquí</a>
                        </div>
                }
            </div>
            <div className='control-btn-up-enlaces'>
                {
                    edit
                    ?<button className='btn_danger' onClick={() => setEdit(!edit)}>Salir de la edición</button>
                    :<button className='btn_info'  onClick={() => setEdit(!edit)}>Editar</button>
                }
            </div>
        </div>
    )
}

export default Enlaces
